import React from "react";
import "./FooterSection.css";
// Import icons from a library like react-icons if preferred,
// but here we use standard anchor tags for the social section.
import { Link } from "react-router-dom";
import zikrmefooterimage from "../../assets/zikrmefooterimage.png";
import {
  FaFacebookF,
  FaInstagram,
  FaXTwitter,
  FaLinkedinIn,
  FaWhatsapp,
} from "react-icons/fa6";
const FooterSection = () => {
  return (
    <footer className="footer-container">
      <div className="footer-overlay">
        <div className="footer-content">
          {/* Top Section: Links Grid */}
          <div className="footer-grid">
            <div className="footer-column">
              <h3>Contact</h3>
              <ul>
                <li>📍 Uttar Pradesh, India</li>
                <li>📞7310624101</li>
                <li>
                  <Link to="./">✉️ info@zikrme.com</Link>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Company</h3>
              <ul>
                <li>Home</li>
                <li>About us</li>
                <li>Hotels</li>
                <li>Restaurants</li>
                <li>Cars</li>
                <li>Contact Us</li>
                <li>Blog</li>
                <li>Workspace</li>
                <li>Hospitals Near Me</li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Explore</h3>
              <ul>
                <li>Vacations</li>
                <li>Top Destination</li>
                <li>Perfect Holiday</li>
                <li>Real Adventure</li>
                <li>Celebration</li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Legal Information</h3>
              <ul>
                <li>Privacy Policy</li>
                <li>Terms & Conditions</li>
                <li>Connect</li>
              </ul>
            </div>
          </div>

          {/* Bottom Section: Branding and Socials */}
          <div className="footer-bottom">
            <div className="view360-btn" onclick="alert('360 View Clicked')">
              <div className="arrow clockwise"></div>
              <div className="arrow anticlockwise"></div>
              <div className="view360-text">360°</div>
            </div>
            <div className="brand-section">
              <img src={zikrmefooterimage} alt="image-footer" />

              <p className="brand-tagline">
                India's Smart Travel & Lifestyle Platform
              </p>
              <p className="copyright">© 2026 ZikRme. All Rights Reserved</p>
            </div>

            <div className="social-section">
              <p>Follow Us</p>
              <div className="social-icons">
                <FaFacebookF />
                <FaInstagram />
                <FaXTwitter />
                <FaLinkedinIn />
                <FaWhatsapp />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
